import { unescapeIdentifier } from '@angular/compiler';
var TokenService = (function () {
    function TokenService() {
    }
    // 从url取出token，进行set到本地
    TokenService.prototype.setTokenAndUserId = function () {
        var _this = this;
        console.log('头部url；', window.location.search);
        return new Promise(function (resolve, reject) {
            if (_this.getQueryString('token')) {
                console.log('设置token', _this.getQueryString('token'));
                localStorage.setItem('transtalen-token', _this.getQueryString('token'));
            }
            if (_this.getQueryString('userIdEncoder')) {
                console.log('设置userIdEncoder', _this.getQueryString('userIdEncoder'));
                localStorage.setItem('transtalenuserid', _this.getQueryString('userIdEncoder'));
            }
            if (_this.getQueryString('source_env')) {
                console.log('设置source_env', _this.getQueryString('source_env'));
                localStorage.setItem('source_env', _this.getQueryString('source_env'));
            }
            resolve();
        });
    };
    TokenService.prototype.getQueryString = function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var params = window.location.search.substr(1).match(reg);
        if (params != null)
            return unescapeIdentifier(params[2]);
        return null;
    };
    TokenService.prototype.findToken = function () {
        this.setTokenAndUserId();
        var token = this.getQueryString('token') || localStorage.getItem('transtalen-token');
        console.log('取到的token', token);
        return token ? token : '';
    };
    TokenService.prototype.findUserIdEncoder = function () {
        this.setTokenAndUserId();
        var userIdEncoder = this.getQueryString('userIdEncoder') || localStorage.getItem('transtalenuserid');
        console.log('取到的userIdEncoder', userIdEncoder);
        return userIdEncoder ? userIdEncoder : '';
    };
    return TokenService;
}());
export { TokenService };



// WEBPACK FOOTER //
// ./src/app/tokenService.service.ts.pre-build-optimizer.js